export default {
  plugins: []
};
